import cx from 'classnames'
import { type ReactNode } from 'react'

type ListContainerGapSize = 'xs' | 'sm' | 'base'

interface ListContainerProps {
  gapSize?: ListContainerGapSize
  className?: string
  children?: ReactNode
}

const ListContainer = ({
  gapSize = 'base',
  className,
  children,
}: ListContainerProps) => {
  return (
    <div
      className={cx(
        'flex flex-wrap',
        {
          'gap-x-1 gap-y-1': gapSize === 'xs',
          'gap-x-1.5 gap-y-1': gapSize === 'sm',
          'gap-x-2 gap-y-1.5': gapSize === 'base',
        },
        className,
      )}
    >
      {children}
    </div>
  )
}

export default ListContainer
